define('components/course/models/slide-type/post-test',[
    "components/course/models/slide-type/tei-wrapper"
], function(BaseModel) {
    "use strict";

    var PostTestModel = BaseModel.extend({
        "populateDefaultData": function() {
            if (!this.get('data')) {
                this.set('data', {
                    "teaGUID": null,
                    "title": null,
                    "studentResponseScore": 0,
                    "positiveFeedback": null,
                    "negativeFeedback": null,
                    "maxScore": null,
                    "thresholdScore": null,
                    "thresholdAsPercent": false,
                    "thresholdValue": null,
                    "bAddCustomFeedback": false,
                    "sCustomFeedback": "",
                    "userScoreStatus": null,
                    "maxScoreStatus": null
                });
            }
            BaseModel.prototype.populateDefaultData.call(this);
            return this;
        },

        "_getSaveStateJSONStructure": function() {
            return {
                "saveState": {
                    "studentResponse": {
                        "assessmentGuid": null,
                        "items": [],
                        "currentPageDisplayed": null,
                        "badgeEarned": false
                    }
                }
            };
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "teaGUID": null,
                    "title": null,
                    "studentResponseScore": null,
                    "positiveFeedback": null,
                    "negativeFeedback": null,
                    "maxScore": null,
                    "thresholdScore": null,
                    "thresholdAsPercent": null,
                    "thresholdValue": null,
                    "globalComponentData": null
                }
            });
        }
    }, {
        "VISIBLE_STATE": {
            "TEI_PAGE": 0,
            "RESULT_PAGE": 1,
            "REVIEW_RESPONSES_PAGE": 2
        }
    });

    return PostTestModel;
});

